import deepSignApi from '@/api/deepsign/deepsignApi';
import type { AxiosRequestConfig } from 'axios';
import type { AutographPosition } from '@/types/AutographPosition';

export interface SignatureField {
  autographPositions: Array<AutographPosition>;
  signFieldName?: string;
}

//TODO @daniel.henkiel missing api definition - not yet part of @deepcloud/api-deep-sign
/**
 * Assign a signature field to a signature slot of a signee group for a file.
 *
 * `PUT /api/v1/documents/{documentId}/signee-groups/{signeeGroupId}/files/{fileId}/signature-slots/{signatureSlot}`
 *
 * @param documentId The document (envelope) the signee group belongs to
 * @param signeeGroupId The signee group to update
 * @param fileId The file to assign the signature field for
 * @param signatureSlot The signature slot index
 * @param data Signature field payload
 * @param config Optional axios request config
 */
export const updateSigneeGroupSignatureField = (
  documentId: string,
  signeeGroupId: string,
  fileId: string,
  signatureSlot: number,
  data: SignatureField,
  config?: AxiosRequestConfig
) =>
  deepSignApi.put<void>(
    `documents/${documentId}/signee-groups/${signeeGroupId}/files/${fileId}/signature-slots/${signatureSlot}`,
    data,
    config
  );
